import type { Frame } from "@/api/spaces";
import {
  frameTitle,
  metadataNeedsConversationBinding,
  type ConversationMetadataArgs,
} from "@/lib/conversation-frame-node";

export function conversationFrameTitlePatch(
  currentTitle: string | undefined,
  args: ConversationMetadataArgs,
): string | undefined {
  if (!args.agentName) return undefined;
  const nextTitle = frameTitle(args.agentName);
  if (currentTitle === nextTitle) return undefined;
  if (currentTitle && !currentTitle.startsWith("Chat with ")) {
    return undefined;
  }
  return nextTitle;
}

export function conversationFrameNeedsBinding(
  frame: Pick<Frame, "metadata" | "title">,
  args: ConversationMetadataArgs,
): boolean {
  return (
    metadataNeedsConversationBinding(frame.metadata ?? {}, args) ||
    conversationFrameTitlePatch(frame.title, args) !== undefined
  );
}
